import React from "react";

export default function EmailPatterns({ data }) {
  return (
    <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-50 relative mt-4">
      <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
        <span className="text-[16px] text-text-700 mr-3 font-bold">
          Email Patterns
        </span>
      </div>
      <div className="px-4 mb-4 space-y-2">
        <div className="flex justify-between text-sm mb-4 mt-1">
          <span>Pattern</span>
          <span>Usage %</span>
        </div>
        {data &&
          data &&
          data.length > 0 &&
          data.map((item) => (
            <div className="flex justify-between text-sm mt-2">
              <span>{item?.pattern}</span>
              <span>{item?.usage_percentage}</span>
            </div>
          ))}
      </div>
    </div>
  );
}
